export const imageSchemaHandle = {
  handle (node, {objectApiName, info: {_objectApiName}, pageType}) {
    node.props.data = {
      apiName: node.apiName,
      version: node.version,
      objectApiName: _objectApiName || objectApiName
    }
    if (pageType === 'list') {
      node.props.firstImgOnly = true
    }
    node.props.ediTable = (String(typeof (node.props.isPureText)) === 'boolean') ? !node.props?.isPureText : node.props.ediTable
  }
}

export const imageProps = {
  // 上传时额外参数
  data: {
    type: Object,
    default: () => ({})
  },
  // 图片 在列表 和 从对象 的展示状态  true列表只显示一张 false从对象
  firstImgOnly: {
    type: Boolean,
    default: false
  },
  // 最大上传数量
  maxUploadNum: {
    type: Number,
    default: 5
  },
  // 是否开启切片上传
  isChunk: {
    type: Boolean,
    default: true
  },
  // 是否多选
  multiple: {
    type: Boolean,
    default: true
  },
  // 文件列表的类型
  listType: {
    type: String,
    default: 'picture-card' // text,picture,picture-card
  },
  // 附件｜图片 true图片 false附件
  onlyImage: {
    type: Boolean,
    default: true
  },
  // 只读
  disabled: {
    type: Boolean,
    default: false
  },
  // 文件列表
  fileList: {
    type: Array,
    default: () => []
  },
  /*
    访问权限
    def 默认，open 公开访问，notopen 私有访问
    def 图片文件公开访问，非图片文件私有访问
  */
  permission: {
    type: String,
    default: 'def'
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: false
  },
  // 主从 样式
  miniMode: {
    type: Boolean,
    default: false
  }
}